
/** Доступный namespace  */
export const namespaces = [
  {ns: "skos", uri:"http://www.w3.org/2004/02/skos/core#"},
  {ns: "rdfs", uri:"http://www.w3.org/2000/01/rdf-schema#"}, 
  {ns: "rdf", uri:"http://www.w3.org/1999/02/22-rdf-syntax-ns#"},
  {ns: "adms", uri:"http://www.w3.org/ns/adms#"},
  {ns: "dcat", uri:"http://www.w3.org/ns/dcat#"},
  {ns: "owl", uri:"http://www.w3.org/2002/07/owl#"},
  {ns: "dcterms", uri:"http://purl.org/dc/terms/"},
  {ns: "foaf", uri:"http://xmlns.com/foaf/0.1/"}, 
  {ns: "vCard", uri:"http://www.w3.org/2006/vcard/ns#"},
  {ns: "xml", uri:"http://www.w3.org/XML/1998/namespace"},
  {ns: "xsd", uri:"http://www.w3.org/2001/XMLSchema#"},
  {ns: "dcat", uri:"http://www.w3.org/ns/dcat#"},
  {ns: "skos", uri:"http://www.w3.org/2004/02/skos/core#"},
  {ns: "wdrs", uri:"http://www.w3.org/2007/05/powder-s#"},
  {ns: "voaf", uri:"https://lov.linkeddata.es/vocommons/voaf/v2.3/"},
  {ns: "csi", uri:"http://csi.semanticpro.org/2016/ns#"},
  {ns: "hbz", uri:"http://hbz.ru/ontologies/emd/"},
  {ns: "spdx", uri:"http://spdx.org/rdf/terms#"},
  {ns: "time", uri:"http://www.w3.org/2006/time#"},  	
  ];
